module.exports = __webpack_public_path__ + "static/media/GiftIcon.31e49f57.svg";